import { useContext } from "react";
import { PersonAddressDataNewsletterAndDisclosureSettings } from "../../../../generated/data-contracts";
import { AvisSection, AvisValueRow } from "../../../shared/components/form";
import { AvisContext } from "../../../shared/context/AvisContext";

interface IContactInformationProps {
  personData?: PersonAddressDataNewsletterAndDisclosureSettings;
}

export function ContactInformation(props: Readonly<IContactInformationProps>) {
  const { personData } = props;
  const { res } = useContext(AvisContext);

  const col1 = 5;
  const col2 = 7;

  const renderPhoneNumbers = () => {
    if (personData?.correspondencePhoneNumbers?.length === 0) {
      return res("message_NoData");
    }

    return (
      <>
        {personData?.correspondencePhoneNumbers?.map((item) => {
          return (
            <div
              key={item.id}
            >{`${item.phoneNumber} - ${item.name} ${item.surname}`}</div>
          );
        })}
      </>
    );
  };

  return (
    <AvisSection classNameIn="contact-information grid">
      <AvisValueRow
        rowTitle={res("authors_ContactInfoPage_label_LegalAddress")}
        rowValue={
          personData?.legalAddress
            ? personData.legalAddress
            : res("message_NoData")
        }
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      <AvisValueRow
        rowTitle={res("authors_ContactInfoPage_label_CorrespondenceAddress")}
        rowValue={
          personData?.correspondenceAddress
            ? personData.correspondenceAddress
            : res("message_NoData")
        }
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      <AvisValueRow
        rowTitle={res("authors_ContactInfoPage_label_email")}
        rowValue={personData?.email ? personData.email : res("message_NoData")}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
      <AvisValueRow
        rowTitle={res("authors_ContactInfoPage_label_phones")}
        rowValue={renderPhoneNumbers()}
        rowTitleCols={col1}
        rowValueCols={col2}
      />
    </AvisSection>
  );
}
